import { useNavigate } from "react-router-dom";
import { useState } from "react";
import LogoSection from "../../components/Logo";
import TwitchView from "../../components/Twitch";
import PTwitchView from "../../components/PTwitch";
import { IconButton, Badge, Divider } from "@chakra-ui/react";
import { FiArrowLeft, FiArrowRight, FiEye, FiGlobe, FiClock, FiMenu } from 'react-icons/fi';
import { Gamepad } from '@styled-icons/fa-solid/Gamepad';

const LargeLogo = () => {
    return (
        <div className="relative md:w-[772.5px] md:h-[450px] w-[347.625px] h-[202.5px]">
            <img src="./images/logomark.png" className="absolute md:pr-[374px] md:max-h-[450px] pr-[168.3px] max-h-[202.5px] object-cover" alt="logomark" />
            <img src="./images/logotype.png" className="absolute md:pt-[125px] md:pb-[117px] md:pl-[87px] md:max-w-[772.5px] pt-[56.18px] pb-[52.5px] pl-[39.16px] max-w-[347.625px] object-cover" alt="logotype" />
        </div>
    )
}

const BadgeGroup = () => {
    return (
        <div style={{ display: 'flex', gap: '10px', bottom: '0', alignItems: 'end' }}>
            <Badge backgroundColor={'#004EEB'} borderRadius={'16px'} padding={'4px 8px'} alignItems={'center'} gap={'4px'} height={'25px'} display={'flex'}>
                <div style={{ display: 'flex', color: 'white' }}><FiEye size={'16px'} /> 15K</div>
            </Badge>
            <Badge backgroundColor={'#6927DA'} borderRadius={'16px'} padding={'4px 8px'} alignItems={'center'} gap={'4px'} height={'25px'} display={'flex'}>
                <div style={{ display: 'flex', color: 'white' }}><FiGlobe size={'16px'} /> English</div>
            </Badge>
            <Badge backgroundColor={'#F79009'} borderRadius={'16px'} padding={'4px 8px'} alignItems={'center'} gap={'4px'} height={'25px'} display={'flex'}>
                <div style={{ display: 'flex', color: 'white' }}><FiClock size={'16px'} /> 15min ago</div>
            </Badge>
        </div>
    )
}
const LiveMatchComponent = ({ name }) => {
    return (
        <div className="flex flex-col gap-6 md:w-[395px] w-[322px]">
            <TwitchView channel={name} />
            <div className="flex gap-[10px] w-full">
                <img src="./images/Avatar.png" alt="avatar" className="object-cover justify-center rounded-full w-[64px] h-[64px]" />
                <div className="flex flex-col gap-3">
                    <div className="flex flex-col gap-1">
                        <p className="text-white text-lg">{name}</p>
                        <p className="text-gray-300 text-sm">David Beckham</p>
                    </div>
                    <BadgeGroup />
                </div>
            </div>
        </div>
    )
}
const PastMatchComponent = ({ name }) => {
    return (
        <div className="flex flex-col gap-6 w-[240px]">
            <PTwitchView channel={name} width={240} height={136} />
            <div style={{ display: 'flex', gap: '10px', marginTop: '24px' }}>
                <img src="./images/Avatar.png" alt="avatar" style={{ objectFit: 'cover', justifyContent: 'center', borderRadius: '50%', width: '40px', height: '40px' }} />
                <div>
                    <p style={{ color: 'white', fontSize: '18px' }}>{name}</p>
                    <p style={{ color: '#D0D5DD', fontSize: '14px' }}>David Beckham</p>
                </div>
            </div>
        </div>
    )
}
const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className="md:w-[1280px] w-full">
            <div className=" flex flex-wrap items-center justify-between mx-auto p-4">
                <LogoSection logowidth={103} logoheight={60} />
                <button
                    data-collapse-toggle="navbar-default"
                    type="button"
                    className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden  dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                    aria-controls="navbar-default"
                    aria-expanded={isMenuOpen}
                    onClick={toggleMenu}
                >
                    <span className="sr-only">Open main menu</span>
                    <svg
                        className="w-5 h-5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 17 14"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M1 1h15M1 7h15M1 13h15"
                        />
                    </svg>
                </button>
                <div
                    className={`${isMenuOpen ? '' : 'hidden'
                        } w-full md:block md:w-auto`}
                    id="navbar-default"
                >
                    <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg  md:flex-row md:space-x-8 md:mt-0 md:border-0  dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
                        <li><a href="/bet" className="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent  md:p-0 dark:text-white md:dark:text-blue-500"
                            aria-current="page">Home</a></li>
                        <li><a href="/live" className="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent  md:p-0 dark:text-white md:dark:text-blue-500"
                            aria-current="page">Live Betting</a></li>
                        <li><a href="/tournament" className="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent md:p-0 dark:text-white md:dark:text-blue-500"
                            aria-current="page">Tournament</a></li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

function Homepage() {
    const navigate = useNavigate();
    const login = () => {
        console.log('login')
        navigate('/live')
    }
    return (
        <div style={{ backgroundColor: 'black' }}>
            <div className="bg-cover bg-no-repeat bg-center flex flex-col" style={{ backgroundImage: `url('./images/background.gif')` }}>
                {/* <div className="flex md:py-6 md:px-20 py-3 pr-2 pl-4 justify-between">
                    <LogoSection logowidth={103} logoheight={60} />
                    
                </div>*/}
                <div className="flex md:justify-between md:py-6 md:px-8 py-3 px-4 items-center">
                    <Navbar />
                    <button onClick={() => login()} className="md:w-[151px] md:h-[44px] md:flex md:bg-gradient-to-r md:from-red-500 md:to-purple-500 md:hover:to-purple-600 text-white md:py-[10px] md:px-[18px] md:rounded-lg rounded-full md:shadow-md md:font-bold">
                        <p className="md:flex hidden self-center">Connect Wallet</p>
                    </button>
                </div>

                <div className="flex flex-col gap-6 md:px-28 px-4 items-center mt-9 mb-28">
                    <LargeLogo />
                    <p className="text-white font-aeonik md:text-[32px] text-2xl font-[500] text-center">Where Classic Gaming Meets Modern Rewards!</p>
                </div>

            </div>

            {/* UPCOMING TOURNAMENT */}
            <div className="flex items-center justify-center">
                <div className="flex flex-col md:py-24 md:px-8 py-8 px-4 gap-8 justify-center md:w-[1280px] w-full">
                    <div className="flex flex-col md:gap-5 gap-3 justify-start">
                        <div className="flex md:flex-row flex-col gap-2">
                            <p className="md:order-1 order-2 md:text-5xl text-4xl font-monopol font-semibold text-white">UPCOMING TOURNAMENT ALERT!</p>
                            <Badge className="md:order-2 order-1 md:self-center self-start" borderRadius={'16px'} display={'flex'} padding={'4px 12px'} color={'var(--orange-500, #EF6820)'} background={'rgba(255, 98, 0, 0.30)'} fontSize={'14px'}>
                                Hot 🔥
                            </Badge>
                        </div>
                        <p className="md:w-[768px] w-[343px] font-aeonik md:text-lg text-base font-[400] text-gray-300">Get ready to unleash your skills in our next grand event. With significant prizes and unlimited excitement, every game is a chance to prove your mettle. Stay tuned for details and be part of the next gaming revolution!"</p>
                    </div>
                    <div className="flex justify-center">
                        <div className="md:w-[1216px] md:h-[420px] w-full h-full overflow-hidden">
                            <img src="./images/fifa.png" alt="fifa" className="object-center object-cover rounded-3xl" />
                        </div>
                    </div>

                </div>
            </div>

            {/* CHOOSE YOUR CHAMPION */}
            <div className="flex items-center justify-center">
                <div className="grid md:grid-cols-2 grid-cols-1 md:py-24 md:px-8 py-8 px-4 md:gap-16 gap-8 justify-center md:w-[1280px] w-full">
                    <div className="md:w-[576px] w-full flex flex-col items-start md:gap-10 gap-3 flex-1">
                        <div className=" text-white font-monopol leading-normal md:text-[96px] text-5xl font-semibold"> Choose Your Champion - Place Your Bet!</div>
                        <p className="self-stretch font-aeonik text-gray-300 md:text-lg text-base font-[400px] leading-7 ">Welcome to the betting arena of Arcade CA$HINO. Here, you decide the winners, place your bets on your favorite players, and revel in the triumph of victory. Your game, your rules</p>
                    </div>
                    <div className="flex items-center justify-center">
                        <img src="./images/Mega.png" alt="logomark" className="rounded-[10px] w-full" />
                    </div>
                </div>
            </div>

            {/* HOW IT WORKS */}
            <div className="flex items-center justify-center">
                <div className="flex flex-col md:gap-16 gap-8 md:px-8 px-4 md:pb-24 py-8 justify-center md:w-[1280px] w-full">
                    <div className="flex flex-col md:gap-5 gap-3 md:w-[768px] w-full self-start">
                        <p className="text-white font-monopol md:text-5xl text-4xl font-semibold">How It Works</p>
                        <p className="text-gray-300 font-aeonik md:text-lg text-base">Pick the player you believe in and bet your $CASH. Witness the Win: Watch the match and cheer for your champion. Claim Your Rewards: Winners enjoy their well-deserved payout!</p>
                    </div>

                    <div className="grid md:grid-cols-3 grid-cols-1 self-center gap-3 px-3">
                        <img src="./images/how1.svg" alt="logomark" />
                        <img src="./images/how2.svg" alt="logomark" />
                        <img src="./images/how3.svg" alt="logomark" />
                    </div>

                    <div className="flex flex-col gap-6">
                        <div className="flex justify-between">
                            <div className="flex items-center gap-[5px]">
                                <div className="rounded-full w-[8px] h-[8px] bg-red-500"></div>
                                <p className="text-white font-aeonik font-bold text-base">LIVE MATCHES</p>
                            </div>
                            <div className="hidden md:flex gap-[6px]">
                                <button className="bg-black text-white py-[7px] px-[13px]"><FiArrowLeft /></button>
                                <button className="bg-black text-white py-[7px] px-[13px]"><FiArrowRight /></button>
                            </div>
                        </div>
                        <div className="flex gap-4 md:overflow-hidden overflow-auto items-start self-stretch">
                            <LiveMatchComponent name={'valorant'} />
                            <LiveMatchComponent name={'cutieloony'} />
                            <LiveMatchComponent name={'k3soju'} />
                            <LiveMatchComponent name={'tfblade'} />
                        </div>
                    </div>

                    <div>
                        <div className="flex justify-between">
                            <div className="flex items-center gap-3">
                                <Gamepad className="text-white" size={24} />
                                <p className="text-white font-bold font-aeonik text-16px">PAST MATCHES</p>
                                <button><p className="text-14px text-purple-500">View All</p></button>
                            </div>
                            <div className="hidden md:flex">
                                <IconButton backgroundColor={'black'} color={'white'} icon={<FiArrowLeft />} />
                                <IconButton backgroundColor={'black'} color={'white'} icon={<FiArrowRight />} />
                            </div>
                        </div>
                        <div className="flex gap-16 md:overflow-hidden overflow-auto">
                            <PastMatchComponent name={'valorant'} />
                            <PastMatchComponent name={'cutieloony'} />
                            <PastMatchComponent name={'k3soju'} />
                            <PastMatchComponent name={'tfblade'} />
                            <PastMatchComponent name={'k3soju'} />
                            <PastMatchComponent name={'tfblade'} />
                        </div>
                    </div>
                </div>
            </div>

            {/* ABOUT */}
            <div className="flex items-center justify-center">
                <div className="grid md:grid-cols-2 grid-cols-1 md:gap-16 gap-12 md:py-6 md:px-8 py-8 px-4 justify-center w-[1280px]">
                    <div className="flex flex-col md:gap-10 gap-9 justify-center">
                        <div className="flex flex-col gap-3">
                            <p className="text-purple-500 text-base">About us</p>
                            <p className="text-white font-monopol font-semibold md:text-5xl text-4xl">CLASSIC GAMING MEETS MODERN REWARDS</p>
                        </div>
                        <p className="text-gray-300 md:text-lg text-base">Welcome to CA$HINO, a universe where gaming transcends boundaries. We're combining the nostalgic euphoria of arcade games with contemporary esports and integrating it all with a cutting-edge web3 betting platform. Participants can dive into various tournaments, face off in Player vs Player battles, bet on their favorite competitors, or strive for high scores in arcade classics and modern hits alike."</p>
                    </div>
                    <img
                        src="./images/about1.png"
                        alt="about"
                        className="rounded-10 w-full"
                    />
                </div>
            </div>

            <div className="flex flex-col py-12 gap-6">
                <div className="grid md:grid-cols-2 grid-cols-1 md:px-28 px-4 md:justify-between gap-8 w-full">
                    <LogoSection logowidth={103} logoheight={60} />
                </div>
                <div className="flex flex-col md:gap-0 gap-6">
                    <Divider />
                    <div className="flex md:justify-between justify-center md:pt-8 md:px-28 md:gap-8 w-full">
                        <p className="text-gray-300 md:justify-start justify-center">© 2077 Arcade CA$HINO. All rights reserved.</p>
                        <div className="hidden md:flex gap-3">
                            <p className="text-gray-300 text-base">Terms</p>
                            <p className="text-gray-300 text-base">Privacy</p>
                            <p className="text-gray-300 text-base">Cookies</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Homepage;